<template>
	<v-layout row wrap>
		<v-flex d-flex xs12>
			<v-card color="primary" dark>
				<v-card-text><h3>{{numberOfModules > 1 ? "Źródła finansowania kosztów modułu " + moduleNumber :
						"Źródła finansowania kosztów"}}
					<span v-if="showPrintInfo" class="d-none print-only-inline"> (Wydruk próbny!)</span>
				</h3></v-card-text>
			</v-card>
		</v-flex>
	</v-layout>
</template>
<script>
	export default {
		name: "costsSummaryTitle",
		props: {
			numberOfModules: {
				default: 0
			},
			moduleNumber: {
				default: ''
			},
			showPrintInfo: {
				type: Boolean, default: false
			}
		}
	};
</script>
